import { Link } from "@tanstack/react-router";
import { useT } from "@/lib/i18n";

export default function HVIFooter() {
  const { t } = useT();
  return (
    <footer className="px-4 md:px-6 py-4 border-t border-border bg-[var(--hvi-surface-container)] text-[10px] md:text-xs text-muted-foreground space-y-3">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
        <span className="uppercase tracking-wider">{t("footer.sources")}:</span>
        <div className="flex flex-wrap gap-x-4 gap-y-1">
          <a href="https://www.who.int/emergencies/disease-outbreak-news" target="_blank" rel="noreferrer" className="hover:text-hvi-primary">WHO Disease Outbreak News</a>
          <a href="https://promedmail.org" target="_blank" rel="noreferrer" className="hover:text-hvi-primary">ProMED-mail</a>
          <a href="https://www.cdc.gov/hantavirus/" target="_blank" rel="noreferrer" className="hover:text-hvi-primary">CDC Hantavirus</a>
          <a href="https://www.ecdc.europa.eu" target="_blank" rel="noreferrer" className="hover:text-hvi-primary">ECDC</a>
          <a href="https://www.arcgis.com/apps/dashboards/5c68442d2afc42d7ba2696e4cd393729" target="_blank" rel="noreferrer" className="hover:text-hvi-primary">ArcGIS Hantavirus Dashboard</a>
          <span>
            Map: <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer" className="hover:text-hvi-primary">© OpenStreetMap</a>
            {" "}contributors, <a href="https://carto.com/attributions" target="_blank" rel="noreferrer" className="hover:text-hvi-primary">© CARTO</a>
          </span>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-between gap-2 border-t border-border pt-3">
        <span>{t("footer.copy")}</span>
        <div className="flex flex-wrap gap-4 uppercase tracking-wider">
          <Link to="/about" className="hover:text-hvi-primary">About</Link>
          <Link to="/resources" className="hover:text-hvi-primary">{t("footer.protocols")}</Link>
          <Link to="/status" className="hover:text-hvi-primary">{t("footer.status")}</Link>
          <Link to="/privacy" className="hover:text-hvi-primary">{t("footer.privacy")}</Link>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new CustomEvent("hvi-consent-open"))}
            className="uppercase tracking-wider hover:text-hvi-primary cursor-pointer"
          >
            Cookie preferences
          </button>
          <span>
            {t("footer.designed")}{" "}
            <a
              href="https://alphy.studio"
              target="_blank"
              rel="noreferrer"
              className="text-hvi-primary hover:underline"
            >
              Alphy Studio
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
